




import { Component, Prop, Vue } from 'vue-property-decorator';
import cms from '@/store/modules/cms';

@Component({})
export default class AdvantagesBlock extends Vue {
    @Prop() public name!: string;

    get blockExists() {
        return cms.blockByName(this.name);
    }

    public getHtml(blockName: string) {
        return cms.blockByName(blockName).html;
    }
}
